import { useEffect, useState } from "react";
import DashboardLayout from "@/components/layout/DashboardLayout";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { Download } from "lucide-react";

export default function Statements() {
  const [txns, setTxns] = useState([]);
  useEffect(() => { api.get("/transactions").then((r) => setTxns(r.data)).catch(() => {}); }, []);

  const download = () => {
    const header = "date,loan_id,amount,method,status\n";
    const rows = txns.map((t) => `${t.created_at},${t.loan_id},${t.amount},${t.method},${t.status}`).join("\n");
    const blob = new Blob([header + rows], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a"); a.href = url; a.download = `finzpe-statement.csv`; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <div className="text-xs uppercase tracking-widest text-primary font-semibold">Statements</div>
            <h1 className="font-display text-3xl mt-2">Transaction history</h1>
          </div>
          <Button onClick={download} variant="outline" className="rounded-full" data-testid="statement-download"><Download className="h-4 w-4 mr-2" />Download CSV</Button>
        </div>
        <Card className="p-0 overflow-hidden">
          <Table>
            <TableHeader><TableRow><TableHead>Date</TableHead><TableHead>Loan</TableHead><TableHead>Amount</TableHead><TableHead>Method</TableHead><TableHead>Status</TableHead></TableRow></TableHeader>
            <TableBody>
              {txns.length === 0 && <TableRow><TableCell colSpan={5} className="text-center text-muted-foreground py-8">No transactions yet.</TableCell></TableRow>}
              {txns.map((t) => (
                <TableRow key={t.id}>
                  <TableCell>{new Date(t.created_at).toLocaleString()}</TableCell>
                  <TableCell className="font-mono text-xs">{t.loan_id.slice(0, 8)}</TableCell>
                  <TableCell>₹{Number(t.amount).toLocaleString("en-IN")}</TableCell>
                  <TableCell className="capitalize">{t.method.replace("_"," ")}</TableCell>
                  <TableCell><span className="text-xs px-2 py-1 rounded-full bg-emerald-500/10 text-emerald-600">{t.status}</span></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Card>
      </div>
    </DashboardLayout>
  );
}
